import React__default from 'react';

function isNamedComponent(child, name) {
  return React__default.isValidElement(child) && typeof child !== 'string' && 'type' in child && typeof child.type !== 'string' && child.type.displayName === name;
}

export { isNamedComponent };
